<template>
  <navbar
    position="fixed"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        JG Estates - 07760 777748
      </router-link>
    </template>
    <template slot="navbar-menu">
       <li class="nav-item">
        <nav-link to="/" class="nav-link">
          Home
        </nav-link>
      </li>

       <li class="nav-item">
        <nav-link to="/services" class="nav-link">
          Services
        </nav-link>
      </li>

      <!-- <li class="nav-item">
        <nav-link to="/aboutus" class="nav-link">
          About Us
        </nav-link>
      </li> -->

      <li class="nav-item">
        <nav-link to="/contactus" class="nav-link">
          Contact Us
        </nav-link>
      </li>

      <!-- <drop-down
        tag="li"
        title="Services"
        class="nav-item"
      >
        <nav-link to="/components">
          Evictions
        </nav-link>
        <a
          href="https://demos.creative-tim.com/vue-now-ui-kit-pro/documentation"
          target="_blank"
          class="dropdown-item"
        >
          Tenant Sourcing
        </a>
      </drop-down> -->
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from "@/components";
import { Popover } from "element-ui";
export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover,
  },
  methods: {
    removeAccount () {
      console.log('close')
    }
  }
};
</script>

<style scoped>
</style>
